// Visit The Stimulus Handbook for more details 
// https://stimulusjs.org/handbook/introduction
// 
// This example controller works with specially annotated HTML like:
//
// <div data-controller="hello">
//   <h1 data-target="hello.output"></h1>
// </div>

import { Controller } from '@hotwired/stimulus'
import Logger from '../lib/logger'
// import CableReady from 'cable_ready'  // Temporarily removed
import consumer from "../channels/consumer"

export default class extends Controller {
 	
  initialize() {
  }

  connect() {
    Logger.debug('Subscribed to Notifications_qbundle_0 Channel');
    this.subscription = consumer.subscriptions.create({ channel: "NotificationsChannel", key: "qbundle_0"}, {
     received (data) {
      Logger.debug('Data received from Notifications_qbundle_0 Channel');
      		// if (data.cableReady) CableReady.perform(data.operations)  // Temporarily removed
     } 
    });
  }

  disconnect(){
    Logger.debug('qbundle controller disconnected');
    consumer.subscriptions.remove(this.subscription)
  	//this.subscription.unsubscribe();
  }
}




